// extracted by mini-css-extract-plugin
export default {"introduction":"QQrpPWHMDw","info":"NIHOFnLhzk"};
    if(module.hot) {
      // 1648554109925
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  